<template>
  <div class="match-recommend-content">
    <router-link
      v-for="item of matches"
      :key="item.id"
      :to="getMatchUrl(item.match_id, item.sport_id)"
      @click.native="contClick(item.sport_id)"
      class="fsbc match-item-content inPlay-content"
    >
      <div class="fc item-left not-start-left">
        <div class="match-logo" @click.stop.prevent>
          <img
            class="img-24 mr-16"
            :src="
              require(`../../assets/img/home/icon/game_tiyu_${
                sports[item.sport_id] || 'default'
              }.png`)
            "
          />
        </div>
        <div
          class="match-title text-overflow-twoline"
          :class="'tags-letter-' + item.first_letter"
        >
          {{ item.comp_short_zh || item.comp }}
        </div>
        <div class="match-time">
          {{ getMatchTime(item.time || item.match_time, true) }}
        </div>
        <!--足球类状态-->
        <div class="match-status" v-if="item.sport_id == 1">
          <strong
            v-if="item.raw_match_status < 2 || item.raw_match_status > 7"
            >{{
              [1, 8].includes(item.raw_match_status)
                ? item.match_detail_status.split("")[0]
                : item.match_detail_status
            }}</strong
          >
          <span class="timeing" v-else>
            {{ item.time_played }}+
            <span class="fb-minute-symbol">
              <em v-show="showFootballMinute">′</em>
            </span>
          </span>
        </div>
        <!--篮球类状态-->
        <div class="match-status" v-else>
          <strong v-if="item.time_played == 0">{{
            [1, 10].includes(item.raw_match_status)
              ? item.match_detail_status.split("")[0]
              : item.match_detail_status
          }}</strong>
          <span class="timeing" v-if="item.time_played > 0"
            >{{ item.match_detail_status }} {{ item.time_played_str }}</span
          >
        </div>
        <div class="bar"></div>
      </div>

      <div class="match-row-center team">
        <div class="team-item">
          <div class="match-name text-overflow">
            <template
              v-if="
                item.sport_id == 1 &&
                item.f_home_score !== null &&
                item.raw_match_status >= 2 &&
                item.raw_match_status <= 8
              "
            >
              <span class="plate-red" v-if="item.f_home_score.red_card > 0">{{
                item.f_home_score.red_card
              }}</span>
              <span
                class="plate-yellow"
                v-if="item.f_home_score.yellow_card > 0"
                >{{ item.f_home_score.yellow_card }}</span
              >
            </template>
            <strong>{{ item.home }}</strong>
          </div>
          <div class="logo">
            <img
              class="match-hometeam-logo"
              :src="
                item.home_logo ||
                require(`./img/match_logo_${
                  sports[item.sport_id] || 'default'
                }.png`)
              "
              alt=""
            />
          </div>
        </div>
        <dl class="match-score">
          <dt>
            <span
              :id="`score_home_${item.match_id}`"
              :data-score="item.home_score"
              v-if="[1, 3].includes(Number(item.match_status))"
            >
              {{ item.home_score }}
            </span>
            <span v-else></span>
          </dt>
          <dd>{{ [1, 3].includes(Number(item.match_status)) ? "-" : "VS" }}</dd>
          <dt>
            <span
              :id="`score_away_${item.match_id}`"
              :data-score="item.away_score"
              v-if="[1, 3].includes(Number(item.match_status))"
            >
              {{ item.away_score }}
            </span>
            <span v-else></span>
          </dt>
        </dl>
        <div class="team-item">
          <div class="logo">
            <img
              class="match-hometeam-logo"
              :src="
                item.away_logo ||
                require(`./img/match_logo_${
                  sports[item.sport_id] || 'default'
                }.png`)
              "
              alt=""
            />
          </div>
          <div class="match-name text-overflow">
            <strong>{{ item.away }}</strong>
            <template
              v-if="
                item.sport_id == 1 &&
                item.f_away_score !== null &&
                item.raw_match_status >= 2 &&
                item.raw_match_status <= 8
              "
            >
              <span class="plate-red" v-if="item.f_away_score.red_card > 0">{{
                item.f_away_score.red_card
              }}</span>
              <span
                class="plate-yellow"
                v-if="item.f_away_score.yellow_card > 0"
                >{{ item.f_away_score.yellow_card }}</span
              >
            </template>
          </div>
        </div>
      </div>

      <div class="item-right">
        <div class="bar"></div>
        <dl
          class="half-corner-score"
          v-if="
            item.sport_id == 1 &&
            item.f_home_score !== null &&
            item.raw_match_status >= 2 &&
            item.raw_match_status <= 8
          "
        >
          <dt>
            半{{ item.f_home_score.half_score }}-{{
              item.f_away_score.half_score
            }}
          </dt>
          <dd>
            角{{ item.f_home_score.corner_kick }}-{{
              item.f_away_score.corner_kick
            }}
          </dd>
        </dl>
        <div class="half-corner-score" v-else></div>
        <div class="fdsbc match-btns">
          <div class="match-live" v-if="item.anchor_id">
            <img src="./img/live_going.png" alt="" />
            <div style="margin-top: 0.02rem">直播中</div>
          </div>
          <div class="match-live" v-else>
            <img src="./img/no-live.png" alt="" />
          </div>
        </div>
        <div class="fc more-anchors">
          <div v-for="(anchor, index) of item.liveAnchors" :key="index">
            <img
              class="img-48 anchor"
              :src="anchor.anchor_avatar"
              @click.stop.prevent="toLive(anchor.anchor_id)"
            />
          </div>
        </div>
        <div
          class="favorite"
          :class="{ active: isActiveFavorite(item) }"
          @click.stop.prevent="favoriteMatch(item)"
        ></div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { post } from "@/util/http";
import { mapState, mapMutations } from "vuex";
import defaultAvatar from "@/components/match-recommend/img/default_logo.png";
export default {
  data() {
    return {
      //收藏的比赛
      favoriteMatches: {},
      //足球是否有进行中的赛事
      footballStarting: 0,
      //篮球是否有进行中的赛事
      basketballStarting: 0,
      //足球进行时间后面的分钟闪动符号的值
      showFootballMinute: true,
      //足球进行中的分钟动画效果定时器句柄
      timer_footer_minute: 0,
    };
  },
  props: {
    pendingMatch: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    matches() {
      let liveAnchors = Array.from({
        length: 1,
      }).fill({
        anchor_avatar: defaultAvatar,
      });

      return this.pendingMatch.map((item) => {
        //如果足球有进行中的赛事
        if (
          item.sport_id == 1 &&
          item.raw_match_status >= 2 &&
          item.raw_match_status <= 7
        ) {
          this.footballStarting++;
        }
        //如果篮球有进行中的赛事
        if (
          item.sport_id == 2 &&
          item.raw_match_status >= 2 &&
          item.raw_match_status <= 9
        ) {
          this.basketballStarting++;
        }
        let arr = [];

        if (item.anchor_id) {
          const anchor_ids = item.anchor_id.split(",");
          const anchor_avatars = item.anchor_avatar.split(",");

          liveAnchors.forEach((anchor, index) => {
            let obj = {
              ...anchor,
            };

            if (anchor_ids[index]) obj.anchor_id = anchor_ids[index];
            if (anchor_avatars[index])
              obj.anchor_avatar = anchor_avatars[index];

            arr.push(obj);
          });
        } else {
          arr = liveAnchors;
        }

        item.liveAnchors = arr;

        return item;
      });
    },
  },
  created() {
    this.match_ids = [];
    this.timer = null;
    this.sports = {
      1: "football",
      2: "basketball",
    };
  },
  watch: {
    pendingMatch: {
      deep: true,
      handler() {
        // 清除定时器
        this.clearTimer();
        this.startUpdateMatchStatus();
      },
    },
  },

  methods: {
    ...mapMutations(["toggleLogin"]),

    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },

    /**
     * 判断赛事类型并返回链接地址
     * 只有足球和蓝球才返回可跳转的地址
     * @param {int} match_id 赛事ID
     * @param {int} sport_id 赛事分类
     */
    getMatchUrl(match_id, sport_id) {
      if (![1, 2].includes(sport_id)) {
        return this.$route.fullPath;
      } else {
        return `/scheduleDetail/${match_id}/${sport_id}`;
      }
    },

    /**
     * 阻止链接跳转
     * @param {int} sport_id 赛事分类
     */
    contClick(sport_id) {
      if (![1, 2].includes(sport_id)) {
        this.$parent.setShowToast("暂无动画直播~");
      }
    },

    // 开始轮训
    startUpdateMatchStatus() {
      if (this.pendingMatch.length > 0) {
        this.match_ids = [];

        this.pendingMatch.forEach((match) => {
          if (match.match_status === 1) {
            this.match_ids.push(match.match_id);
          }
        });

        if (this.match_ids.length <= 0) return;

        this.getMatchScoreStatus();

        this.timer = setInterval(() => {
          this.getMatchScoreStatus();
        }, 10000);
      }
    },

    getMatchScoreStatus() {
      if (this.$route.path !== "/schedule") {
        this.clearTimer();
        return;
      }

      const params = {
        match_ids: this.match_ids,
        sport_id: this.matches[0].sport_id,
      };

      post({
        url: "/api/match/getMatchScoreList",
        data: params,
      }).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.updateListScore(res.data?.data?.matchScoreList ?? []);
        }
      });
    },

    updateListScore(matches = []) {
      matches.forEach((match) => {
        setTimeout(() => {
          const { match_id, home_score, away_score } = match;
          const homeEle = document.getElementById(`score_home_${match_id}`);
          const awayEle = document.getElementById(`score_away_${match_id}`);

          if (homeEle) {
            const old_score = homeEle.getAttribute("data-score");
            if (home_score !== Number(old_score)) {
              homeEle.innerHTML = home_score;
              homeEle.setAttribute("data-score", home_score);
            }
          }

          if (awayEle) {
            const old_score = awayEle.getAttribute("data-score");
            if (away_score !== Number(old_score)) {
              awayEle.innerHTML = away_score;
              awayEle.setAttribute("data-score", away_score);
            }
          }
        }, 30000);
      });
    },

    toLive(id) {
      if (id && id !== 0) {
        this.$router.push(`/liveMatchesTwo/${id}`);
      }
    },

    getMatchTime(time, type) {
      const date = new Date(time * 1000);
      const MM = date.getMonth() + 1;
      const DD = date.getDate();
      const hh = date.getHours();
      const mm = date.getMinutes();
      if (type) {
        return `${hh < 10 ? "0" + hh : hh}:${mm < 10 ? "0" + mm : mm}`;
      } else {
        return `${MM < 10 ? "0" + MM : MM}-${DD < 10 ? "0" + DD : DD}`;
      }
    },

    enterRoom(live) {
      this.$router.push({
        path: `/liveMatchesTwo/${live.anchorid}`,
      });
    },

    handleReservation(id) {
      if (!id) {
        return;
      }
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }

      post({
        url: "/api/match/reserveMatch4Crawler",
        data: {
          match_id: id,
        },
      })
        .then(({ data: { data } }) => {
          this.$message({
            message: "预约成功",
            type: "success",
            duration: 2000,
          });
          this.$emit("refresh");
        })
        .catch((e) => {
          this.$message({
            message: e,
            type: "error",
            duration: 2000,
          });
        });
    },

    cancelHandleReservation(id) {
      if (!id) {
        return;
      }
      post({
        url: "/api/match/cancelReserveMatch4Crawler",
        data: {
          match_id: id,
        },
      })
        .then(() => {
          this.$message({
            message: "取消预约",
            type: "warning",
            duration: 2000,
          });
          this.$emit("refresh");
        })
        .catch((e) => {
          this.$message({
            message: e,
            type: "error",
            duration: 2000,
          });
        });
    },

    isActiveFavorite(item) {
      if (this.favoriteMatches[item.match_id]) {
        return this.favoriteMatches[item.match_id] === 1;
      } else {
        return item.favorite === 1;
      }
    },

    favoriteMatch(match = {}) {
      // 如果未登陆
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }

      // 2是取消 1是关注
      let operate = match.favorite === 1 ? 2 : 1;

      if (this.favoriteMatches[match.match_id]) {
        operate = this.favoriteMatches[match.match_id] === 1 ? 2 : 1;
      }

      const params = {
        match_id: match.match_id,
        operate,
        sport_id: match.sport_id,
      };

      post({
        url: "/api/match/favoriteMatch",
        data: params,
      }).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          const obj = {};
          obj[match.match_id] = operate;
          this.favoriteMatches = {
            ...this.favoriteMatches,
            ...obj,
          };

          this.$emit("favorite-match", operate === 1 ? 1 : -1);
        }
      });
    },
  },

  /**
   * 页面加载完自动加载区域
   */
  updated() {
    this.$nextTick(function () {
      //判断当前页面上是否有进行中的足球分钟数
      if (this.footballStarting > 0) {
        clearTimeout(this.timer_footer_minute);
        //改变足球后面分钟符号的闪动效果
        this.timer_footer_minute = setTimeout(() => {
          if (this.showFootballMinute === true) {
            this.showFootballMinute = false;
          } else {
            this.showFootballMinute = true;
          }
        }, 1000);
      }
      //判断当前页面上是否有进行中的篮球分钟数(动画效果产品说暂时不做)
      if (this.basketballStarting > 0) {
        //停止足球的动画
        clearTimeout(this.timer_footer_minute);
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.fsbc {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.fcc {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fc {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.fdsbc {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.ml-4 {
  margin-left: 4px;
}

.ml-8 {
  margin-left: 8px;
}

.ml-16 {
  margin-left: 16px;
}

.mr-16 {
  margin-right: 16px;
}

.img-48 {
  width: 0.48rem;
  height: 0.48rem;
}

.pointer {
  cursor: pointer;
}

.match-recommend-content {
  .team {
    flex: 1;
  }

  .score {
    flex: 1;
    text-align: right;
  }

  .inPlay {
    width: 100%;
    height: 48px;
    padding: 12px 24px;
  }

  .not-start {
    background: #f0f0f0;
  }

  .type-title {
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
  }

  .today-match {
    font-size: 14px;
    line-height: 24px;
    color: #999999;
    justify-content: flex-end;
  }

  a.match-item-content {
    width: 100%;
    height: 0.64rem;
    overflow: hidden;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0.12rem 0.2rem;
    position: relative;

    &:hover {
      background: linear-gradient(
          90deg,
          rgba(41, 241, 158, 0.1) 0%,
          rgba(3, 163, 248, 0.1) 100%
        ),
        linear-gradient(0deg, #ffffff, #ffffff),
        linear-gradient(270deg, #ffffff 47.39%, #e9fbf5 100%);
    }
  }

  .match-item-content:nth-child(2n) {
    background-color: #f9f9fb;
  }

  .item-left {
    flex-shrink: 0;
    float: left;
    width: 3.8rem;
    height: 100%;
    overflow: hidden;
  }

  .match-logo {
    flex-shrink: 0;
    display: block;
    float: left;
    width: 0.48rem;
    height: 0.24rem;
    overflow: hidden;

    img {
      display: block;
      height: 100%;
    }
  }

  .match-title {
    flex-shrink: 0;
    width: 0.75rem;
    height: 0.24rem;
    line-height: 0.24rem;
    overflow: hidden;
    border-radius: 0.02rem;
    font-size: 0.14rem;
    text-align: center;
  }

  .match-time {
    flex-shrink: 0;
    display: block;
    float: left;
    width: 0.98rem;
    height: 100%;
    line-height: 0.4rem;
    overflow: hidden;
    font-size: 0.2rem;
    color: #333333;
    font-weight: bold;
    text-align: center;
  }

  .match-status {
    display: block;
    float: left;
    width: 100%;
    height: 100%;
    line-height: 0.4rem;
    overflow: hidden;

    strong {
      font-size: 0.2rem;
      color: #999;
    }

    .timeing {
      font-weight: bold;
      font-size: 0.16rem;
      color: #db6372;

      .fb-minute-symbol {
        display: inline-block;
        width: 0.05rem;
        height: 0.3rem;
        overflow: hidden;
        font-size: 0.2rem;
        text-align: left;
        vertical-align: middle;
        position: relative;

        em {
          width: 0.05rem;
          height: 0.2rem;
          line-height: 0.2rem;
          position: absolute;
          z-index: 2;
          top: 0;
        }
      }
    }
  }

  .date {
    font-size: 12px;
    color: #666666;
  }

  .match-desc {
    width: 160px;
    max-height: 72px;
    font-size: 14px;
    color: #666666;
    line-height: 18px;
    word-wrap: break-word;
    margin-right: 36px;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .match-hometeam-logo {
    max-width: 0.32rem;
    height: 0.32rem;
  }

  .bar {
    display: block;
    float: right;
    width: 0.01rem;
    height: 100%;
    background: #f0f0f0;
  }

  .match-row-center {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    width: 6.1rem;
    height: 100%;
    line-height: 0.4rem;
    overflow: hidden;

    .plate-red,
    .plate-yellow {
      display: inline-block;
      min-width: 0.15rem;
      height: 0.21rem;
      line-height: 0.21rem;
      overflow: hidden;
      vertical-align: top;
      margin: 0px 3px;
      margin-top: 0.08rem;
      border-radius: 0.02rem;
      font-size: 0.16rem;
      font-weight: bold;
      color: #fff;
      text-align: center;
    }

    .plate-red {
      background-color: #f64d5c;
    }

    .plate-yellow {
      background-color: #fdcc48;
    }

    .team-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 2.8rem;
      height: 100%;
      overflow: hidden;

      .match-name {
        width: 100%;
        height: 100%;
        line-height: 0.4rem;
        overflow: hidden;
      }

      .match-name strong {
        font-size: 0.16rem;
        font-weight: bold;
        color: #333333;
        padding: 0px 0.1rem;
      }

      &:first-child .match-name {
        text-align: right;
      }

      .logo {
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 0.4rem;
        height: 0.4rem;
        overflow: hidden;
        background-color: #f6f6f6;
        border: 1px solid #dcdcdc;
        border-radius: 0.4rem;
        padding: 0.05rem;
      }
    }

    .match-score {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 1.35rem;
      color: #333333;
      font-weight: bold;
      font-size: 0.24rem;
      text-align: center;

      dd {
        padding: 0px 0.1rem;
      }
    }
  }

  .item-right {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 2.8rem;
    height: 100%;
    padding-right: 0.1rem;

    .half-corner-score {
      flex-shrink: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1.1rem;
      height: 100%;
      overflow: hidden;
      padding: 0px 0.05rem;
      font-size: 0.14rem;
      color: #666;
      text-align: left;

      dt {
        width: 100%;
        padding-right: 0.1rem;
      }

      dd {
        width: 100%;
      }
    }

    .favorite {
      flex-shrink: 0;
      display: block;
      float: right;
      width: 0.24rem;
      height: 0.24rem;
      background-image: url("~@/views/schedule/img/un-favorite.png");
      background-size: contain;

      &.active {
        background-image: url("~@/views/schedule/img/is-favorite.png");
      }
    }
  }

  .match-vs {
    width: 105px;
    padding: 0 4px;
    font-size: 20px;
    color: #666666;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    margin-right: 30px;
  }

  .match-awayteam-name {
    text-align: left;
    margin-left: 16px;
  }

  .more-anchors {
    height: 24px;
    text-align: right;
    display: flex;

    // flex-direction: row-reverse;
    .anchor {
      margin-left: 0.12rem;
      cursor: pointer;
      border-radius: 0.24rem;
    }
  }

  .into-anchor {
    border-radius: 50%;
  }

  .match-btns {
    .match-live {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 0.14rem;
      color: #666;
    }

    img {
      width: 0.32rem;
    }
  }

  .match-recommend-btn {
    width: 0.92rem;
    height: 0.32rem;
    text-align: center;
    line-height: 0.32rem;
    font-size: 0.18rem;
    color: #ffffff;
    font-weight: 500;
    background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
    border-radius: 0.16rem;
  }

  .match-order-btn {
    color: #fff;
    background: #02a8a2;
    cursor: pointer;
  }

  .match-ordered-btn {
    background: rgba(2, 168, 162, 0.1);
    border: 1px solid #02a8a2;
    color: #02a8a2;
  }

  .inPlay-content {
    &:hover {
      background: rgba(0, 0, 0, 0.04);

      .not-start-left {
        background: none;
      }

      .item-left {
        background-image: none;
      }
    }
  }
}
</style>
